export default __webpack_public_path__ + "static/media/anti-slip_black.dc728151.webp";